import React, { useEffect, useMemo, useState } from 'react';
import {
   Alert,
   API_ENDPOINTS,
   Card,
   CardBody,
   customToast,
   FormInput,
   FormLabel,
   route,
   useDisabledContext,
   useForm,
   useLangContext,
   Variants,
} from 'carrier-fe';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';


const defaultValues = {
   review_text: '',
   review_rating: 0,
};

type ReviewFormValues = typeof defaultValues;

function ReviewForm() {
   const params = useParams();
   const [searchParams] = useSearchParams();
   const installationId = params.installationId || '';
   const ratingFromParams = Number(searchParams.get('rating'));
   const [error, setError] = useState('');
   const { disabled } = useDisabledContext();
   const { crud } = useLangContext();

   const handleSubmit = async (values: ReviewFormValues) => {
      return await axios.post(route(API_ENDPOINTS.HOUSEHOLDER.REVIEW.STORE,{
         installationId,
      }), {
            review_text: values.review_text,
            review_rating: values.review_rating,
        });
   };

   const { setValues, errors, isSuccess, data, store, Submit } = useForm(handleSubmit, {
      ...defaultValues,
      review_rating: ratingFromParams,
   });

   const btnLabel = useMemo(() => {
      return {
         defaultLabel: crud?.buttons?.submit?.default || 'Submit',
         loadingLabel: crud?.buttons?.submit?.submitting || 'Submitting...',
      };
   }, [crud]);

   useEffect(() => {
      if (isSuccess) {
         window.location.reload();
      }
   }, [isSuccess]);

   return (
      <div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow-md">
         {error && (
            <Alert className="mb-4">
               <p className="text-red-600">{error}</p>
            </Alert>
         )}

         <div className="d-flex flex-column gap-4">
            <div className="d-flex flex-column">
               <FormLabel label={'Your Rating'} name={'rating_label'} />
               <StarRating rating={store?.review_rating} />
            </div>
            <FormInput
               type={'textarea'}
               label="Your Review"
               value={store?.review_text}
               name={'review_text'}
               onChange={(value: any) => {
                  setValues({ review_text: value });
               }}
               errorMessages={errors?.review_text}
            />
            <div className="mt-auto w-full">
               <Submit
                  disabled={disabled}
                  defaultLabel={btnLabel.defaultLabel}
                  loadingLabel={btnLabel.loadingLabel}
               />
            </div>
         </div>
      </div>
   );
}

export default ReviewForm;

const StarRating = ({ rating, maxStars = 5 }: { rating: number; maxStars?: number }) => {
   const stars = [];

   for (let i = 1; i <= maxStars; i++) {
      if (i <= rating) {
         stars.push(<i key={i} className="bi bi-star-fill text-warning me-1 fs-4"></i>);
      } else {
         stars.push(<i key={i} className="bi bi-star text-secondary me-1 fs-4"></i>);
      }
   }

   return <div>{stars}</div>;
};
